import React from 'react';
import _ from 'lodash';
import { Link } from '@/components/link';

export type LinkListItem = {
  title: string;
  url: string;
  as?: string;
  children?: LinkListItem[];
};

type LinkListProps = {
  items: LinkListItem[];
};

const LinkList = ({ items }: LinkListProps) => {
  const validItems = items.filter((item) => item.url && item.title);

  return (
    <ul>
      {_.map(validItems, (item) => (
        <li key={`link-list-${_.kebabCase(item.title)}`}>
          <Link href={item.url} as={item.as} eventText={item.title}>
            {item.title}
          </Link>

          {item.children && <LinkList items={item.children} />}
        </li>
      ))}
    </ul>
  );
};

export default LinkList;
